import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { SectionBanner, Paragraph, Box } from 'components';
import { BANNER_ACTIONS } from 'constants/analytics';
import { analytics } from 'core/analytics';

import CommunityProjectsManager from 'apps/home/community/projects/appManager';

@withNamespaces()
@inject('routerStore')
@observer
export default class CommunityProjects extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new CommunityProjectsManager(null, this.props);
  }

  render() {
    const { t } = this.props;
    const projectsConnection = this.appManager.projectsConn;
    const projects = projectsConnection.arrayApp;

    return (
      <>
        <Header />
        <MainWrapper>
          <SectionBanner
            bannerId='why-share-projects'
            imageSrc='/assets/banners/001.svg'
            title='Build on great ideas.'
            buttonText='Learn more'
            linkName='https://help.wikifactory.com/en/articles/4617994-get-started-with-projects'
            paddingTop='xlarge'
            paddingBottom='xxlarge'
            eventCallback={() =>
              analytics.sendEvent(BANNER_ACTIONS.COMMUNITY_PROJECTS)
            }
          >
            <Box>
              <Paragraph>
                Don't start from scratch, or reinvent the wheel.
              </Paragraph>
              <Paragraph>
                <strong>Contribute and build upon public Projects</strong> from
                the community.
              </Paragraph>
              <Paragraph>
                Your skills and expertise can{' '}
                <strong>help great ideas go further</strong>.
              </Paragraph>
            </Box>
          </SectionBanner>
          <CardSection
            invisible={this.appManager.loading}
            title={t('All Projects')}
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={projects}
            CardComponent={ProjectCard}
            noDataCardType='project'
            spaceType='discover'
            gridColumns={3}
          />
        </MainWrapper>
      </>
    );
  }
}

CommunityProjects.propTypes = {
  t: PropTypes.func,
};
